var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41406 19.957C5.60547 19.7617 2.17188 17.2852 0.726563 13.6797C0.25 12.4961 0.0351562 11.3477 0.0351562 10C0.0351562 8.65234 0.25 7.50391 0.726563 6.32031C2.04688 3.02734 4.99219 0.683594 8.49609 0.132812C9.36328 -0.00390625 10.6133 -0.00390625 11.5078 0.132812C14.6836 0.617187 17.4922 2.66797 18.9219 5.55078C19.6484 7.00781 19.9648 8.36719 19.9648 10C19.9648 11.6367 19.6445 12.9961 18.9219 14.4531C17.9648 16.375 16.3711 17.9727 14.4531 18.9219C12.8398 19.7227 11.2461 20.0469 9.41406 19.957ZM13.9844 13.4609C14.3281 13.2344 14.4023 12.6836 14.1289 12.3867C14.082 12.3359 13.3008 11.6992 12.3945 10.9687L10.7422 9.64844V6.94141C10.7422 5.17578 10.7266 4.1875 10.6992 4.08984C10.6484 3.90625 10.4531 3.67578 10.2852 3.60937C10.125 3.53906 9.875 3.53906 9.71484 3.60937C9.54297 3.67969 9.34766 3.91016 9.29688 4.09766C9.26953 4.20312 9.25781 5.21484 9.26563 7.23437C9.27734 10.1445 9.27734 10.2187 9.35547 10.3516C9.45313 10.5195 13.1563 13.5 13.3359 13.5547C13.5234 13.6133 13.8203 13.5703 13.9844 13.4609Z",
    fill: "#7363F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.0759030d3d6c849e7750b9ec600103b3.svg";
export { ForwardRef as ReactComponent };